import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import CardIcon from 'components/shared/CardIcon';
import Paginate from 'components/shared/Paginate';
import Table from 'components/shared/Table';
import Text from 'components/shared/layouts/Text';

const StyledContainer = styled.div`
  .paginate-container {
    padding-top: ${theme.spaces.large}px;
  }
`;

const getColumns = () => {
  const columns = [
    {
      dataIndex: 'cardType',
      title: null,
      width: '5%',
      render: (row) => <CardIcon cardType={row?.cardType} />,
    },
    {
      dataIndex: 'cardNumber',
      title: 'CARD NUMBER',
      width: '25%',
      render: (row) => <Text weight={600}>**** **** **** {row?.cardNumber}</Text>,
    },
    {
      dataIndex: 'expires',
      title: 'EXPIRES',
      width: '70%',
      render: (row) => (
        <Text weight={600}>
          {row?.cardMonth} / {row?.cardYear}
        </Text>
      ),
    },
  ];

  return columns;
};

const PaymentMethodsTable = ({ skeletonRowsNum, loading, items, pageCount, currentPage, onPageChange }) => {
  return (
    <StyledContainer>
      <Table columns={getColumns()} rows={items} loading={loading} skeletonRowsNum={skeletonRowsNum} />
      {!loading && !items?.length && <Text centered>No billing history found</Text>}
      <div className="paginate-container">
        <Paginate pageRangeDisplayed={3} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
      </div>
    </StyledContainer>
  );
};

PaymentMethodsTable.propTypes = {
  skeletonRowsNum: PropTypes.bool,
  loading: PropTypes.bool,
  items: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default PaymentMethodsTable;
